const meta = document.createElement("meta")
meta.name = "naive-ui-style"
document.head.appendChild(meta)

import {createApp} from "vue"
import {createPinia} from "pinia"
import {createI18n} from "vue-i18n"
import {createPersistedState} from "pinia-plugin-persistedstate"
import VueApexCharts from "vue3-apexcharts"
import VueGoogleMaps from "@fawmi/vue-google-maps"
import App from "@/App.vue"
import router from "@/router"
import {getI18NConf, type Locales, type MessageSchema} from "@/lang/config"
import {emitter} from "@/emitter";
import {Logger} from "@/utils"


const pinia = createPinia()
pinia.use(
    createPersistedState({
        key: id => `__persisted__${id}`
    })
)

const i18n = createI18n<MessageSchema, Locales>(getI18NConf())

const app = createApp(App)
app.use(pinia)
app.use(i18n)
app.use(router)
app.use(VueApexCharts)
app.use(VueGoogleMaps, {
    load: {}
})
app.mount("#app")


if (navigator && navigator.serviceWorker) {
    Logger.info('Registering service worker...')
    navigator.serviceWorker
        .register('/sw.js', {scope: './'})
        .then((registration) => {
            Logger.info('Service worker registered...', registration)

            navigator.serviceWorker.addEventListener('message', (event: MessageEvent<any>) => {
                if (event.data && event.data.type !== 'SW') return
                const data = event.data.msg
                Logger.debug('Remote Event (WPN):', data)
                if (!data) return
                const type = data.data?.type
                emitter.emit(`remoteevent:${type}`, data)
            })

            if (navigator.serviceWorker.controller)
                navigator.serviceWorker.controller.postMessage({type: 'install'})

        })
        .catch((error) => {
            Logger.error('Service worker registration failed:', error)
        })

    if (navigator.serviceWorker.controller) {
        Logger.info('Waking up service worker...');
        navigator.serviceWorker.controller.postMessage({type: 'wake-up'})
    }

} else {
    Logger.error('Service worker is not supported in this browser.')
}


router.afterEach(() => {
    if (window.fbq) window.fbq('track', 'PageView');
});
